// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"313":"b9d44c0d","332":"f99c262c","652":"48dc2820"}[chunkId] + ".chunk.js";
};